/**
 * Checa se um valor é truthy.
 * @param {any} val O valor a ser checado.
 * @return {boolean}
 */
export function isTruthy(val) {
  return !!val;
}

export function waitFor(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

const util = {
  isTruthy,
  waitFor,
};

export default util;
